import { render, staticRenderFns } from "./accountlog.vue?vue&type=template&id=a10c05bc&scoped=true&"
import script from "./accountlog.vue?vue&type=script&lang=js&"
export * from "./accountlog.vue?vue&type=script&lang=js&"
import style0 from "./accountlog.vue?vue&type=style&index=0&id=a10c05bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10c05bc",
  null
  
)

export default component.exports